// extracted by mini-css-extract-plugin
export default {"paymentpolicy":"PrivacyPolicy_paymentpolicy__kGkUA"};